import EmblaCarousel from "embla-carousel"
import { addPrevNextBtnsClickHandlers } from "./embla/arrows"
import { addDotBtnsAndClickHandlers } from "./embla/dots"

export default class Gallery {
  constructor() {
    this.emblaNode = document.querySelectorAll(".gallery .embla")

    if (!this.emblaNode.length) return

    this.emblaNode.forEach((node) => this.initCarousel(node))
  }

  initCarousel(node) {
    const viewportNode = node.querySelector(".embla__viewport")

    const leftEdge = node.querySelector(".embla__edge--start")
    const rightEdge = node.querySelector(".embla__edge--end")

    const prevBtnNode = node.querySelector(".embla__button--prev")
    const nextBtnNode = node.querySelector(".embla__button--next")
    const dotsNode = node.querySelector(".embla__dots")

    if (node && viewportNode) {
      const emblaApi = EmblaCarousel(viewportNode, {
        dragThreshold: 5,
        breakpoints: {
          "(min-width: 768px)": {
            align: "center",
            loop: true,
          },
        },
      })

      emblaApi.on("init", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
        this.updateActiveSlide(node, emblaApi)
      })

      // update active class when selection changes
      emblaApi.on("select", () => this.updateActiveSlide(node, emblaApi))

      emblaApi.on("resize", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      emblaApi.on("scroll", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode,
      )
      const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode)

      emblaApi.on("destroy", removeDotBtnsAndClickHandlers)
      emblaApi.on("destroy", removePrevNextBtnsClickHandlers)
    }
  }

  toggleEdges(start, end, emblaApi) {
    // Only show edges on wider viewports (match embla breakpoint behavior)
    if (typeof window !== "undefined" && window.innerWidth < 768) {
      // ensure edges are hidden on small screens
      if (start && start.classList) start.classList.remove("is-visible")
      if (end && end.classList) end.classList.remove("is-visible")
      return
    }

    const progress = Math.round(emblaApi.scrollProgress() * 100)

    if (progress <= 0 && window.innerWidth < 768) {
      start.classList.remove("is-visible")
    } else {
      start.classList.add("is-visible")
    }

    if (progress === 100) {
      end.classList.remove("is-visible")
    } else {
      end.classList.add("is-visible")
    }
  }

  updateActiveSlide(node, emblaApi) {
    const slideNodes = node.querySelectorAll(".embla__slide")
    if (!slideNodes || !slideNodes.length) return

    // clear any existing active class
    slideNodes.forEach((s) => s.classList.remove("is-active"))

    try {
      const selected = emblaApi.selectedScrollSnap()
      const activeSlide = slideNodes[selected]
      if (activeSlide) {
        activeSlide.classList.add("is-active")
      }
    } catch (err) {
      // fallback: use selectedIndex if different API available
      const index =
        emblaApi.selectedIndex && typeof emblaApi.selectedIndex === "number"
          ? emblaApi.selectedIndex
          : null
      if (index !== null && slideNodes[index]) slideNodes[index].classList.add("is-active")
    }
  }
}
